import ApiUtils from "./apiutils";
import S3 from 'aws-sdk/clients/s3';
import 'aws-sdk/lib/node_loader';
import { config } from 'aws-sdk/lib/core';
import { signOut } from "../actions/authActions";
import { push } from "react-router-redux";
import { RESPONSE_STATUS } from './constants';
import { deleteAllCartGoodsData } from "../actions/cartAction";
import ReactGA from 'react-ga';

const base_url = "http://localhost:3000";

let Api = {
  createUser: function(user) {
    return fetch(base_url + "/users", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },

      body: JSON.stringify({
        user: {
          email: user.email,
          password: user.password,
          user_id: user.user_id,
          source: "helloava-web"
        }
      })
    })
      .then(ApiUtils.checkStatus)
      .then(response => response.json())
      .catch(e => e);
  },

  createUserProfile: function(profile) {
    return fetch(base_url + "/userprofile", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },

      body: JSON.stringify({
        user_id: profile.user_id,
        gender: profile.gender,
        skin_type: profile.skin_type,
        age_range: profile.age_range,
        allergies: profile.allergies,
        product_prefs: profile.product_prefs,
        skin_concerns: profile.skin_concerns
      })
    })
      .then(ApiUtils.checkStatus)
      .then(response => response.json())
      .catch(e => e);
  },

  setSkinQuiz: function(skinquiz) {
    return fetch(base_url + "/users", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },

      body: JSON.stringify({
        user: {
          email: skinquiz.email,
          password: skinquiz.password,
          user_id: skinquiz.user_id,
          source: "helloava-web"
        }
      })
    })
      .then(ApiUtils.checkStatus)
      .then(response => response.json())
      .catch(e => e);
  },

  getIdentityToken: function(user_id, nonce, callback) {
    fetch(base_url + "/token", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },

      body: JSON.stringify({
        user_id: user_id,
        nonce: nonce
      })
    })
      .then(ApiUtils.checkStatus)
      .then(response => {
        return response.json();
      })
      .then(data => {
        callback(data["token"]);
      })
      .catch(function(err) {
        return Promise.reject(err.message);
        //return err.response.data;
      });
  },

  authenticate: function(email, password) {
    let formData =
      "email=" +
      encodeURIComponent(email) +
      "&password=" +
      encodeURIComponent(password);
    const isAth = window.location.pathname.includes("/ath");
    const url = isAth
      ? "/api/ath/authenticate"
      : "/api/authenticate";
    return fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: formData
    })
      .then(ApiUtils.checkStatus)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json) {
          //Check if Hair Profile exists
          return this.checkIfSkinProfileExists(json)
            // .then(this.checkIfHairProfileExists(json))
            // .then(this.checkIsShowRecommendation(json))
            .then(this.checkIfPaidGateFee(json))
            .then(!isAth && this.getGenderId(json))
            .then(() => {
              isAth
                ? localStorage.setItem("ath_auth_token", json.token.token)
                : localStorage.setItem("auth_token", json.token.token);
              isAth
                ? localStorage.setItem("ath_user_id", json.userId)
                : localStorage.setItem("user_id", json.userId);
              isAth
                ? localStorage.setItem("ath_user_firstname", json.firstName)
                : localStorage.setItem("user_firstname", json.firstName);
              isAth
                ? localStorage.setItem("ath_user_lastname", json.lastName)
                : localStorage.setItem("user_lastname", json.lastName);
                localStorage.setItem("auth_expires", parseInt(json.token.expires / 1000));

                localStorage.setItem("planTier", json.tier);

                // localStorage.removeItem("recommendations_cart_fetched_with_prod");
                // localStorage.removeItem("cart-products-ids");

                localStorage.setItem("user_global_email", email);

                return this.checkIsShowRecommendation(json).then(()=>{

                  return this.checkIsVisited_scheduleConsult(json).then(()=>{
                    return JSON.stringify(json);
                  }).catch(err =>{return JSON.stringify(json)} )

                }).catch(err =>{return JSON.stringify(json)} )

              
            });
        }
      })
      .catch(error => {
        const statusCode = JSON.parse(error.message).statusCode;
        const message = JSON.parse(error.message).message;
        throw new Error(
          JSON.stringify({ statusCode: statusCode, message: message })
        );
      });
  },

  s3ImageUpload: function(image, filename, type, bucket) {
    let img = new Image();
    img.src = image;

    config.update({
      accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
      arn: process.env.REACT_APP_S3_ARN,
      region: process.env.REACT_APP_S3_REGION
    });

    let s3 = new S3();
    let params = {
      Bucket: bucket,
      Key: filename
    };

    s3.getSignedUrl("putObject", params, function(err, signedUrl) {
      if (!err) {
        let buf = new Buffer(
          image.replace(/^data:image\/\w+;base64,/, ""),
          "base64"
        );
        return fetch(signedUrl, {
          method: "put",
          headers: {
            "Content-Type": type
          },
          mode: "cors",
          body: buf
        })
          .then(ApiUtils.checkStatus)
          .then(response => {
            return response;
          })
          .catch(function(err) {
            //throw new Error(JSON.stringify({statusCode: 400, message:err.message}));
          });
      }
    });
  },

  getUUID: () => {
    return ApiUtils.getUUID();
  },

  getGenderId(obj) {
    if(obj){
      return fetch("/api/user-account-info/" + obj.userId, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth-token": obj.token.token
        }
      })
        .then(response => response.json())
        
        .then(responseJson => {
          localStorage.setItem("user_global_firstname", responseJson.firstName);
          localStorage.setItem("user_global_lastname", responseJson.lastName);
          if(responseJson.email){
            localStorage.setItem("user_global_email", responseJson.email);
          }
          localStorage.setItem("user_global_hasPaid", responseJson.hasPaid);
          localStorage.setItem("user_global_enrollFrom", responseJson.enrollFrom);

          localStorage.setItem("user_global_phone", responseJson.phoneNumber);
          responseJson.gender &&
            localStorage.setItem("user_global_gender", responseJson.gender.id);
        }) .catch(function(err) {
          // alert("There is a problem to get the account info. Please try again.");
          console.log("There is a problem getting your account info.");
        });
    }else {
       return false
    }
  },

  checkIfHairProfileExists: obj => {
    return fetch("/api/hair-profiles?user-id=" + obj.userId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": obj.token.token
      }
    })
      .then(response => {
        if (response.status >= 400 && response.status < 500) return;
        else return response.json();
      })
      .then(responseJson => {
        if (responseJson.length >= 1)
          localStorage.setItem("user_has_hair_profile", true);
      })
      .catch(function(err) {
        console.log(err);
      });
  },

  checkIfSkinProfileExists: obj => {
    return fetch("/api/surveys/result?user-id=" + obj.userId, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": obj.token.token
      }
    })
      .then(response => {
        if (response.status >= 400 && response.status < 500) return;
        return response.json();
      })
      .then(responseJson => {
        if (responseJson.description !== null)
          localStorage.setItem("user_has_skin_profile", true);
          localStorage.setItem("estheticianNote", responseJson['estheticianNote']);
      })
      .catch(function(err) {
        console.log(err);
      });
  },

  checkIsShowRecommendation: obj => {
    return new Promise((resolve, reject) => {
      fetch("/api/user-flags/show-recommendation?user-id=" + obj.userId, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth-token": obj.token.token
        }
      })
        .then(response => {
          if (response.status >= 400 && response.status < 500) return;
          return response.json();
        })
        .then(responseJson => {
          if (responseJson == 'true' || responseJson == true) {
            localStorage.setItem("visited_recommendations",true);
          }else{
            localStorage.setItem("visited_recommendations",false);
          }
          resolve()
        })
        .catch(function(err) {
          localStorage.setItem("visited_recommendations",false);
          console.log(err);
          reject()
        });
    })
  },

  checkIsVisited_scheduleConsult: obj => {
    return new Promise((resolve, reject) => {
      fetch("/api/user-flags/schedule-consult?user-id=" + obj.userId, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-auth-token": obj.token.token
        }
      })
        .then(response => {
          if (response.status >= 400 && response.status < 500) return;
          return response.json();
        })
        .then(responseJson => {
          if (responseJson == 'true' || responseJson == true) {
            localStorage.setItem("visited_scheduleConsult",true);
          }else{
            localStorage.setItem("visited_scheduleConsult",false);
          }
          resolve()
        })
        .catch(function(err) {
          localStorage.setItem("visited_scheduleConsult",false);
          console.log(err);
          reject()
        });
    })
  },

  getPlanTypeTierData : () => {
		const userId = localStorage.getItem("user_id");
			fetch('/api/user-profiles/tier?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
			}).then((response) => response.json()).then(responseJson => {
          localStorage.setItem("planTier", responseJson);
			}).catch(function(err) {
					console.log("resp");
			});
	},

  // Determine whether to paid for the gate fee。true：progress bar states change Consultation
  checkIfPaidGateFee: obj => {
    return fetch('/api/user-flags/gate-fee-paid?user-id=' + obj.userId, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-auth-token': obj.token.token
        }
    }).then((response) => response.json()).then(responseJson => {
        if (responseJson) {
          if(responseJson.error){
            localStorage.setItem("gateFeePaid",false);
          }else{
            localStorage.setItem("gateFeePaid",true);
          }
        }else {
          localStorage.setItem("gateFeePaid",false);
        }
    }).catch(function(err) {
        console.log("There was a problem checking payment status. Please try again.");
    });
  },

  // 处理 token 过期，造成的请求错误
  auth_tokenManager () {
    let auth_expires = localStorage.getItem("auth_expires");
    let nowTime = Math.round(new Date() / 1000)
    if (auth_expires) {
      if (nowTime >= auth_expires) { // token time out
        if(!(window.location.pathname == ("/signin")) && !(window.location.pathname == ("/")) 
            && !(window.location.pathname == ("/reset-password")) && !(window.location.pathname == ("/create-password"))
            && !(window.location.pathname == ("/onboarding")) && !(window.location.pathname == ("/storeonboarding")) 
            && !(window.location.pathname == ("/gift")) && !(window.location.pathname == ("/storeonboarding")) 
            && !(window.location.pathname == ("/gift/thank-you")) && !(window.location.pathname == ("/ath/onboarding"))
            && !(window.location.pathname == ("/ath/login")) && !(window.location.pathname == ("/hair/onboarding"))
        ){
          return Api.fun_gotoSignOut();
        }else{
          return Api.fun_refreshedToken();
        }
      } else if ( (auth_expires - nowTime)  <= 3600 ) { // about to expire within an hour
        return Api.fun_refreshedToken();
      } else {  // get token
        return Api.fun_getToken();
      }
    }else {
      if(!(window.location.pathname == ("/signin")) && !(window.location.pathname == ("/")) 
            && !(window.location.pathname == ("/reset-password")) && !(window.location.pathname == ("/create-password"))
            && !(window.location.pathname == ("/onboarding")) && !(window.location.pathname == ("/startonboarding")) 
            && !(window.location.pathname == ("/gift")) && !(window.location.pathname == ("/storeonboarding")) 
            && !(window.location.pathname == ("/gift/thank-you")) && !(window.location.pathname == ("/ath/onboarding"))
            && !(window.location.pathname == ("/ath/login")) && !(window.location.pathname == ("/hair/onboarding"))
      ){  //已经在登录页面了，没必要跳转了.于是不进去这里
        return Api.fun_gotoSignOut();
      }else{
        return Api.fun_getToken();
      }
    }
  },

  fun_getToken() {
    return window.location.pathname.includes("/ath") ? localStorage.getItem("ath_auth_token") : localStorage.getItem("auth_token")
  },

  // http://localhost:8080/api/refresh-token?user-id=3
  fun_refreshedToken() {
    let token = window.location.pathname.includes("/ath") ? localStorage.getItem("ath_auth_token") : localStorage.getItem("auth_token")
    fetch("/api/refresh-token/?user-id="+localStorage.getItem("user_id") , {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded",
        "x-auth-token": token
      }
    })
    .then(response => response.json())
    .then(responseJson => {
        localStorage.setItem("auth_expires", parseInt(responseJson.token.expires / 1000));
        window.location.pathname.includes("/ath")
        ? localStorage.setItem("ath_auth_token", responseJson.token.token)
        : localStorage.setItem("auth_token", responseJson.token.token);
        return responseJson.token.token
    })
    .catch(function(error) {
      return window.location.pathname.includes("/ath") ? localStorage.getItem("ath_auth_token") : localStorage.getItem("auth_token")
    });
    return window.location.pathname.includes("/ath") ? localStorage.getItem("ath_auth_token") : localStorage.getItem("auth_token")
  },

  // token time out , sign out
  fun_gotoSignOut() {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_firstname");
    localStorage.removeItem("user_lastname");
    localStorage.removeItem("auth_expires");
    localStorage.removeItem("phoneCountry");
    if (localStorage.getItem("auth_token")) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_firstname");
      localStorage.removeItem("user_lastname");
    }
    if (localStorage.getItem("first_time_purchase"))
      localStorage.removeItem("first_time_purchase");
    if (localStorage.getItem("has_purchased"))
      localStorage.removeItem("has_purchased");

    //Remove No Hair Profile Tag
    if (localStorage.getItem("user_has_hair_profile"))
      localStorage.removeItem("user_has_hair_profile");

    //Remove No Hair Profile Tag
    if (localStorage.getItem("user_has_skin_profile"))
      localStorage.removeItem("user_has_skin_profile");

    //Remove ATH
    if (localStorage.getItem("ath_auth_token")) {
      localStorage.removeItem("ath_auth_token");
      localStorage.removeItem("ath_user_id");
      localStorage.removeItem("ath_user_firstname");
      localStorage.removeItem("ath_user_lastname");
    }

    localStorage.removeItem("planTier");
    localStorage.removeItem("visited_recommendations");
    localStorage.removeItem("visited_scheduleConsult");
    localStorage.removeItem("user_account_info");
    localStorage.removeItem("gateFeePaid");
    localStorage.removeItem("doneQuizStepId");
    localStorage.removeItem("email");
    localStorage.removeItem("phone_number");
    localStorage.removeItem("estheticianNote");
    localStorage.removeItem("budget");
    localStorage.removeItem("recommendations_fetched");

    Object.keys(localStorage).forEach(item => {
      if (item.includes("reco")) localStorage.removeItem(item);
      if (item.includes("_global_")) localStorage.removeItem(item);
      if (item.includes("SQ_")) localStorage.removeItem(item);
    });
    window.location.pathname.includes("/ath")
      ? setTimeout(() => {
          window.location.href = process.env.REACT_APP_UL_ATH_BUFFER_PAGE;
        }, 1)
      :  window.location.pathname = "/signin";
      return Api.fun_getToken();
  },


  // 把商品更新进购物车。添加和删除
	saveCartForLater : async (product,cartProductArr,modeAction) => {
    const userId = localStorage.getItem("user_id");
   
    let productArr = cartProductArr;
		var ind = productArr.findIndex(arrProduct => arrProduct.name === product.name);
    let productArrCopy = [];
    var actionTypeValue = "add";

		if (ind < 0) {
      product.quantity = 1
      productArrCopy = [...productArr, product];
      actionTypeValue = "ADD";
		} else {

      if(modeAction == "orderPageAddProduct" || modeAction =="goodsAddProduct" ){
        productArr.forEach(element => {
          if(element.id == product.id){
            element.quantity = Number(element.quantity) +1;
          }
        });
        productArrCopy = productArr;
        actionTypeValue = "ADD";

      }else if(modeAction == "goodsDeleteProduct"){
        productArr.forEach(element => {
          if(element.id == product.id){
            element.quantity = Number(element.quantity) - 1;
            if(element.quantity < 1){
              productArrCopy = [...productArr.slice(0, ind), ...productArr.slice(ind + 1)];
            }
          }
        });

        productArrCopy = productArr;
        actionTypeValue = "DEL";

      }else if(modeAction == "cartGoodsQuantityChange"){

        productArr.forEach(element => {
          if(element.id == product.id){
            element.quantity = Number(product.quantity);
          }
        });
        productArrCopy = productArr;
        actionTypeValue = "ADD";
      }else{
        productArrCopy = [...productArr.slice(0, ind), ...productArr.slice(ind + 1)];
        actionTypeValue = "DEL";
      }
    }
    let prodStr = productArrCopy.map(product => `${[product.id]}:${product.quantity != null ? product.quantity : 1 }`).toString();
    
		if (productArrCopy.length > 0) {

      
      if(localStorage.getItem("auth_token")){
          let authToken = Api.auth_tokenManager();
          return await fetch('/api/carts?user-id=' + userId + '&products=' + prodStr, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-auth-token': authToken
            }
          }).then(response => {
              if ((response.status >= 200 && response.status < 300)) {
                  // 更新购物车中的商品
                  // window.fbq('track', 'AddToCart');
                  return {actionType:actionTypeValue, cartData:productArrCopy};
              }else throw new Error("Response status error.");
          }).catch((err) => {
              alert("There was a problem saving your products: " + err);
              return {actionType:'ERROR', cartData:productArrCopy}
          });
      }else{
         return {actionType:actionTypeValue, cartData:productArrCopy};
      }
		}else {
      // reducer 会调用  clearCart 方法
      return {actionType:'CLEARCART', cartData:productArrCopy}
    }
  },

  // 清空购物车
  clearCart : async() => {
    if(localStorage.getItem("auth_token")){
        const userId = localStorage.getItem("user_id");
        fetch('/api/clear-cart?user-id=' + userId, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-auth-token': Api.auth_tokenManager()
          }
        }).then(response => {
          if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
            return 'CLEARCARTSUCCESS'
          }else throw new Error("Response status error.");
        }).catch((err) => {
            console.log("There was a problem clearing the cart: " + err);
        });
    }else{
      return 'CLEARCARTSUCCESS'
    }
  },

  // 获取购物车中的商品再计算总价格
  calculatePrice :async (cartProductArr) => {
    let sum = 0;
		cartProductArr.forEach(product => {
			if (product && product.price) {
				sum += parseFloat(product.price);
			}
    });
    return sum.toFixed(2)
    // this.setState({ price: sum.toFixed(2) });
    // 返回 商品总价格
	},

  // 获取购物车
  getCart: async () => {
    if(localStorage.getItem("auth_token")){
      const userId = localStorage.getItem("user_id");
      return await fetch('/api/carts?user-id=' + userId, {
          method: 'GET',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'x-auth-token': Api.auth_tokenManager()
          }
        }).then(response => response.json())
        .then(responseJson => {
          localStorage.setItem("cart-products-ids",responseJson.map(product => product.productId))
          if(responseJson && responseJson.length > 0){
            return Api.syncProductArr(responseJson.map(product => product.productId),responseJson);
          }else {
            return []
          }
        }).catch(err => {
            // alert('Get shopping cart products: ' + err);
            return []
        });
    }else{
      return []
    }
  },

  // 获取购物车中的商品id后，请求商品列表。生成商品信息json
  syncProductArr : (ids,cartProducts) => {
    var cartIds = ids
    return Api.fun_fetchProducts(cartIds).then(productsArray => {
        if(cartProducts){
          cartProducts.forEach(cartProObject => {
            productsArray.forEach(proObject => {
              if(cartProObject.productId == proObject.id){
                proObject.quantity = cartProObject.quantity
              }
            })
          });
        }
        return productsArray;
    })
  },

  // The api to fetch products info by ids is
  fun_fetchProducts : async (prodId) => {
		const userId = localStorage.getItem("user_id");
		return await fetch('/api/products?ids='+ prodId , {
			method: 'GET',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'x-auth-token': Api.auth_tokenManager()
			}
		}).then(response => {
			if (response.status >= 400 && response.status < 500) return;
			  else return response.json();
    }).then((responseJSON) => {
        const { status, data } = responseJSON;
        return responseJSON;
    }).catch(function(err) {
			console.log(err);
		});
  },

  fun_shareasaleGetCookie(e){
    var r=e+"=";
    var a=decodeURIComponent(document.cookie);
    var o=a.split(";");
    for(var n=0;n<o.length;n++){
      var t=o[n];
      while(t.charAt(0)==" "){
        t=t.substring(1)
      }
      if(t.indexOf(r)==0){
        return t.substring(r.length,t.length)
      }
    }
      return""
    },

    fun_submitOrderCard(sourceOrderId,imageBase64) {
      const url = '/api/order-card';
      fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-auth-token': Api.auth_tokenManager()
        },
        body: JSON.stringify({
          "orderId": `${sourceOrderId}`,
          "imageBase64": imageBase64,
          "userEmail":localStorage.getItem("user_global_email")
        })
      })
        .then(responseJson => {
          localStorage.setItem("orderRegimenCard",true);
        }).catch(function (err) {
          console.log("There was a problem retrieving customer data: " + err);
        });
    },
    
    fun_getGenderId: async () => {
      const userId = localStorage.getItem("user_id");
      return await  fetch('/api/user-account-info/' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            if(!! responseJson){
                localStorage.setItem("user_account_info", JSON.stringify(responseJson));
            }else{
            }
        }).catch(function(err) {
            console.log("There is a problem to get the account info. Please try again.");
        });
    },
    // 跟踪 onboarding 中的每一个问题（Track every problem in onboarding）
    eventTrackingStageProgress(step) {
        if ((process.env.REACT_APP_ENV === 'prod') || (process.env.REACT_APP_ENV === 'dev') ) {
            if (step === 'signupPurposeId') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 1 - Tell us a bit about how we can help you.",
                    value: 1
                });
            }

            if (step === 'userName') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 2 - What's Your Name?",
                    value: 1
                });
            } else if (step === 'region') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 3 - Do you live in the US?",
                    value: 1
                });
            } else if (step === 'age') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 4 - How old are you?",
                    value: 1
                });
            } else if (step === 'gender') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 5 - Are you Male or Female?",
                    value: 1
                });
            } else if (step === 'ethnicity') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 6 - What is Your Ethnicity?",
                    value: 1
                });
            } else if (step === 'concerns') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 7 - What are your primary skin concerns?",
                    value: 1
                });
            } else if (step === 'productsNew') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 8 - What products are you interested in exploring today?",
                    value: 1
                });
            } else if (step === 'budget') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 8-2 - Budget Question",
                    value: 1
                });
            } else if (step === 'allergys') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 9 - Are you allergic to any of the below ingredients?",
                    value: 1
                });
            } else if (step === 'brand') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal brand - Which of the brands below speak to you?",
                    value: 1
                });
            } else if (step === 'picture') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 10 - Could you take a selfie?",
                    value: 1
                });
            } else if (step === 'A8-1') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 11 - Q1",
                    value: 1
                });
            } else if (step === 'A8-2') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 12 - Q2",
                    value: 1
                });
            } else if (step === 'A8-3') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 13 - Q3",
                    value: 1
                });
            } else if (step === 'A8-4') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 14 - Q4",
                    value: 1
                });
            } else if (step === 'A8-5') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 15 - Q5",
                    value: 1
                });
            } else if (step === 'A8-6') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 16 - Q6",
                    value: 1
                });
            } else if (step === 'A8-7') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 17 - Q7",
                    value: 1
                });
            } else if (step === 'A8-8') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 18 - Q8",
                    value: 1
                });
            } else if (step === 'A8-9') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 19 - Q9",
                    value: 1
                });
            } else if (step === 'A8-10') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 20 - Q10",
                    value: 1
                });
            } else if (step === 'A8-11') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 21 - Q11",
                    value: 1
                });
            } else if (step === 'A8-12') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 22 - Q12",
                    value: 1
                });
            } else if (step === 'createAccount') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal 23 - Create Account",
                    value: 1
                });
            }else if (step === 'pregnant') {
                ReactGA.event({
                    category: 'Onboarding Funnel',
                    action: 'View',
                    label: "Goal-pregnant  - Are you currently pregnant or breastfeeding",
                    value: 1
                });
            }
        }
    }

};

export { Api as default };



// WEBPACK FOOTER //
// ./src/utils/api.js